module.exports = __webpack_public_path__ + "documents/08bf4c94383d8e439a8e29ebaa38aa7b.csv";